import React from "react";

const EmailRead = () => {
  return <div>Email Read</div>;
};

export default EmailRead;
